// extracted by mini-css-extract-plugin
export default {"flex":"style-module--flex--90493","paywallBlock":"style-module--paywallBlock--4c85d","center":"style-module--center--a89c4","imr":"style-module--imr--0e035"};